import React, { createContext, PropsWithChildren, useContext } from 'react';

export type FeatureFlags = {
  readonly [key: string]: string;
};

export function useFeatureFlags(): FeatureFlags {
  return useContext(FeatureFlagsContext);
}

export type FeatureFlagsProviderProps = {
  readonly featureFlags: FeatureFlags;
};

export function FeatureFlagsProvider({
  featureFlags,
  children
}: PropsWithChildren<FeatureFlagsProviderProps>) {
  return (
    <FeatureFlagsContext.Provider
      value={{
        ...featureFlags
      }}
    >
      {children}
    </FeatureFlagsContext.Provider>
  );
}

const FeatureFlagsContext = createContext({});
